(function () {
	'use strict';

	angular
		.module('expo-cupom-digital')
		.controller('AccountController', AccountController)

	/** @ngInject */
	function AccountController($state, UserService, HelperService, sweetAlert) {
		const vm = this;

		vm.logout = () => {
			UserService
				.logout()
				.then(() => {
					$state.go("app.home");
				}, error => HelperService.errorCallback(error));
		};

		vm.submitRegisterForm = () => {
			let user = angular.copy(vm.registerForm);
			if (!user) return

			let params = {
				name: user.name,
				email: user.email,
				id: user.id
			}

			HelperService.startLoading(".content-body", "Enviando seus dados");

			UserService
				.put(params)
				.then(success => {
					console.log('success: ', success);
					HelperService.stopLoading(".register")

					if (success.errors) {
						HelperService.errorCallback(success);
						return
					}

					let config = {
						type: 'success',
						title: 'Sucesso!',
						text: 'Seu cadastro foi atualizado com sucesso!',
						confirmButtonText: 'Continuar',
						showCancelButton: false,
						allowOutsideClick: false,
						allowEscapeKey: false
					};

					sweetAlert
						.swal(config).then(() => {
							UserService.saveLocalUserData(success);
							vm.registerForm = success;
						});
				}, error => {
					HelperService.stopLoading(".register")
					HelperService.errorCallback(error)
				})
		};

		vm.submitPasswordForm = () => {
			let user = angular.copy(vm.registerForm);
			let userPwd = angular.copy(vm.passwordForm);
			if (!user) return

			let params = {
				password: Encrypt.Hash(userPwd.password).toString(),
				id: user.id
			}

			HelperService.startLoading(".content-body", "Atualizando sua senha");

			UserService
				.putPassword(params)
				.then(success => {
					console.log('success: ', success);
					HelperService.stopLoading(".register")

					if (success.errors) {
						HelperService.errorCallback(success);
						return
					}

					let config = {
						type: 'success',
						title: 'Sucesso!',
						text: 'Sua senha foi atualizada com sucesso!',
						confirmButtonText: 'Continuar',
						showCancelButton: false,
						allowOutsideClick: false,
						allowEscapeKey: false
					};

					sweetAlert
						.swal(config).then(() => {
							UserService.saveLocalUserData(success);
							$state.reload();
						});
				}, error => {
					HelperService.stopLoading(".register")
					HelperService.errorCallback(error)
				})
		};

		init();

		function init() {
			vm.registerForm = UserService.getUser();
			vm.registerForm.id = UserService.getUserId();
		}

	}
}());